import i18n from 'i18n'
import * as React from "react"
import { SelectAjaxSeeker } from "ui-seeker/core"
import { FORMAT_DATE_BACK, formatDate } from 'ui-seeker/utils'

import { SelectLoading } from "app/components/loading"
import { COMPETITION_URL } from 'app/@common/constants'
import './SelectHotels.css'


export default function SelectHotels({ section, excludedIds = [], ...props }) {

    if (!props?.isReportForm) {
        if (section === 'packages' && Array.isArray(props.selectedRoute) && !!props.selectedRoute) return <SelectLoading />
        if (section !== 'report' && section !== 'config-panel' && section !== 'overview' && section !== "packages" && !props.date) return <SelectLoading />
    }


    const myProps = {
        urlAjax: COMPETITION_URL.COMPSET,
        placeholder: i18n.t('common:filters.allHotels'),
        icon: { icon: 'hotel' }, 
        extraParams: {
            ...props.date && { dateRange: props.date },
            ...props.mainHotelID && { hotelID: props.mainHotelID },
            ...props.selectedRoute && { routes: props.selectedRoute },
            ...props.id_report_execution && { id_report_execution: props.id_report_execution },
            ...'id_main_hotel' in props && { id_main_hotel: props.id_main_hotel },
            ...props.date === 'custom' && { 
                startDate: formatDate(props.customDates[0], { format: FORMAT_DATE_BACK }),
                endDate: formatDate(props.customDates[1], { format: FORMAT_DATE_BACK })
            }
        },
        formatOptionLabel: ({ label, main, value }, { context }) => <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            {/* Excluded from the compset (from the analyzer table): still selected, shown struck-through */}
            {excludedIds?.some(id => String(id) === String(value)) ?
                <span className="select-hotels-excluded" title={i18n.t('common:compsetExclusion.excluded')}>{label}</span> :
                label
            }
            { main && <span style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '17px',
                height: '17px',
                borderRadius: '50%',
                backgroundColor: '#1976d2',
                color: 'white',
                fontSize: '10px',
                fontWeight: 'bold',
                marginLeft: '4px'
            }}>
                M
            </span>}
        </span>,
        isMulti: true,
        limitedChips: true,
        ...props
    }

    return <SelectAjaxSeeker {...myProps} />
}